export default "__VITE_ASSET__wuz33dP6__"